import { Box } from '@dixa/lib-shared-habla';

import { MenuItem } from './components/menuItem/menuItem';
import styles from './contextMenu.module.scss';

export type Handlers = {
  onAlign: VoidFunction;
  onArrange: VoidFunction;
  onDelete: VoidFunction;
};

type LoadingHandlers = {
  isAlignLoading: boolean;
  isArrangeLoading: boolean;
};

type DisabledHandlers = {
  isAlignDisabled: boolean;
  isArrangeDisabled: boolean;
  isDeleteDisabled: boolean;
};

type Props = {
  onHide: VoidFunction;
  position: [number, number];
  handlers: Handlers;
  loading: LoadingHandlers;
  disabled: DisabledHandlers;
};

export function ContextMenu({
  position,
  handlers,
  loading,
  disabled,
}: Props): JSX.Element {
  return (
    <Box
      background="neutral.000"
      boxShadow="100"
      borderRadius="100"
      style={{
        overflow: 'hidden',
        position: 'fixed',
        left: position[0],
        top: position[1],
      }}
    >
      <ul className={styles.list}>
        <MenuItem
          disabled={disabled.isAlignDisabled}
          loading={loading.isAlignLoading}
          onClick={handlers.onAlign}
          content="Align"
        />
        <MenuItem
          disabled={disabled.isArrangeDisabled}
          loading={loading.isArrangeLoading}
          onClick={handlers.onArrange}
          content="Arrange nodes"
        />
        <MenuItem
          disabled={disabled.isDeleteDisabled}
          onClick={handlers.onDelete}
          color="error"
          content="Delete"
        />
      </ul>
    </Box>
  );
}
